export default __webpack_public_path__ + "static/media/ScoreboardBG.a046b7a6.jpg";